import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from './../../../../themes/services/menu.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@uw/core/services/auth.service';
import { CampaignStateService } from '@uw/core/services/campaign-state.service';
import { CampaignFacadeService } from '@uw/core/facades/campaign.facade.service';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';
import { MatButton } from '@angular/material/button';
import { UwRouterLink } from '../../../../shared/directives/directives/uw-router-link.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    imports: [MatButton, UwRouterLink, TranslateModule]
})
export class LandingPageComponent implements OnInit {

  campaignGuid: string = '';

  isSSOUser: boolean;

  constructor(private menuService: MenuService,
    private authService: AuthService,
    private campaignStateService: CampaignStateService,
    private customNavigationService: CustomNavigationService,
    private campaignFacadeService: CampaignFacadeService,
    private router: Router,
    private _activatedRoute: ActivatedRoute) {
    this.menuService.showDonarSubMenu(true);
  }

  ngOnInit(): void {
    this.campaignGuid = this.campaignStateService.getSelectedCampaign()?.campaignGuid ?? '';
    this.isSSOUser = this.authService.getUser()?.isSSOUser;
  }

  onProfileClick() {
    this.customNavigationService.navigate(
      [
        {
          outlets: {
            'profile-display': 'settings/profile'
          }
        }
      ],
      {
        relativeTo: this._activatedRoute.parent
      }
    );
  }

  onPasswordChange() {
    this.customNavigationService.navigate(
      [
        {
          outlets: {
            sidebar: 'change-password'
          }
        }
      ],
      {
        relativeTo: this._activatedRoute.parent
      }
    );
  }

  //revert before 6.5 release
  // async onLogout(){

  //   if (this.isSSOUser){
  //     this.authService.sso_logOut();
  //   } else {
  //     this.authService.logOut().subscribe(
  //       _ => {
  //           if (this.isSSOUser) {
  //             this.customNavigationService.navigate(['/main', 'sso-login']);
  //           } else {
  //             this.customNavigationService.navigate(['/main', 'login']);
  //           }
  //         }
  //     );
  //   }
  // }

  async onLogout(){
    this.authService.logOut().subscribe(
      _ => {
          if (this.isSSOUser) {
            this.customNavigationService.navigate(['/main', 'sso-login']);
          } else {
            this.customNavigationService.navigate(['/main', 'login']);
          }
        }
    );
  }

  get userFirstName(){
    return this.authService.getUser()?.firstName;
  }


}
